'use strict';

import iconMappings from '../../../node_modules/@peoplepower/ioticons/dist/mapping.json';
import falIconsGlyphs
  from '../../../node_modules/@peoplepower/ioticons/dist/www/iconfonts/Font Awesome Pro/fal-glyphs.json';
import farIconsGlyphs
  from '../../../node_modules/@peoplepower/ioticons/dist/www/iconfonts/Font Awesome Pro/far-glyphs.json';
import fasIconsGlyphs
  from '../../../node_modules/@peoplepower/ioticons/dist/www/iconfonts/Font Awesome Pro/fas-glyphs.json';
import iotlIconsGlyphs
  from '../../../node_modules/@peoplepower/ioticons/dist/www/iconfonts/PPC IOT Icons Light/iotl-glyphs.json';
import iotrIconsGlyphs
  from '../../../node_modules/@peoplepower/ioticons/dist/www/iconfonts/PPC IOT Icons Regular/iotr-glyphs.json';

export default angular
  .module('maestro.services.icon', [])
  .service('IconService', IconService)
  .name;

function IconService(
  $q,
  $http,
  $log,
) {

  const falIcons = Object.keys(falIconsGlyphs);
  const farIcons = Object.keys(farIconsGlyphs);
  const fasIcons = Object.keys(fasIconsGlyphs);
  const iotlIcons = Object.keys(iotlIconsGlyphs);
  const iotrIcons = Object.keys(iotrIconsGlyphs);

  const defaultIconUrl = `assets/icons/far/question.svg`;
  let defaultIcon;

  /**
   * Icon cache
   * @type {Map<string, {url: string, svg?: string | Promise<string>}>}
   */
  const iconRegistry = new Map();

  angular.extend(this, {
    getSvgIcon: getSvgIcon,
    getServerIcon: getServerIcon,
    hasIcon: hasIcon
  });

  init();

  function init() {
    addNamespaceIcons('iotl', 'iotl', iotlIcons);
    addNamespaceIcons('iotr', 'iotr', iotrIcons);

    addNamespaceIcons('fal', 'fal', falIcons);
    addNamespaceIcons('far', 'far', farIcons);
    addNamespaceIcons('fas', 'fas', fasIcons);
  }

  function getSvgIcon(iconName) {
    let record = iconRegistry.get(iconName);
    if (!record) {
      $log.warn(`[Icon Service] Unknown icon '${iconName}'`);
      record = {
        url: defaultIconUrl,
        svg: defaultIcon
      };
      iconRegistry.set(iconName, record);
    }

    if (record.svg) {
      return $q.when(record.svg);
    }
    record.svg = downloadIcon(record.url, iconName);
    record.svg.then((svg) => {
      record.svg = svg;
      if (record.url === defaultIconUrl) {
        defaultIcon = svg;
      }
    });
    return record.svg;
  }

  function hasIcon(iconName) {
    return iconRegistry.some(record => record.name === iconName);
  }

  /**
   * Find available icon to render by icon name passed from server.
   * @param {string} deviceIconName
   * @param {'l' | 'r' | 's'} [preferredStyle]
   */
  function getServerIcon(deviceIconName, preferredStyle) {
    if (!preferredStyle) {
      preferredStyle = 'r';
    }

    const mapping = iconMappings.mapping.find(m => m.old && m.new && m.old === deviceIconName);
    if (mapping) {
      const newName = mapping.new.toLowerCase();
      if (iotlIcons.includes(newName)) {
        if (preferredStyle === 's') {
          preferredStyle = 'r';
        }
        return `iot${preferredStyle} fa-${newName}`;
      }
      if (falIcons.includes(newName)) {
        return `fa${preferredStyle} fa-${newName}`;
      }
    }

    if (iotlIcons.includes(deviceIconName)) {
      if (preferredStyle === 's') {
        preferredStyle = 'r';
      }
      return `iot${preferredStyle} fa-${deviceIconName}`;
    }
    if (falIcons.includes(deviceIconName)) {
      return `fa${preferredStyle} fa-${deviceIconName}`;
    }

    $log.warn(
      `[IconService] The "${deviceIconName}" icon was not found in any of the connected icon collections. ` +
      (mapping?.new
        ? `The mapping file contains a mapping for the "${mapping?.new}" icon in the "${mapping?.iconfont}" collection, but such an icon was also not found.`
        : ''),
    );

    // Default icon (when icon not found)
    return 'far fa-question';
  }

  function addNamespaceIcons(namespace, folderName, iconNames) {
    iconNames
      .forEach(iconName => {
        iconRegistry.set(
          `${namespace} fa-${iconName}`,
          { url: `assets/icons/${folderName}/${iconName}.svg` }
        );
      });
  }

  /**
   * Download icon svg as string
   * @param {string} url
   * @param {string} iconName
   * @returns {Promise<string>}
   */
  function downloadIcon(url, iconName) {
    return $http.get(url)
      .then(response => {
        return response.data;
      })
      .catch((err) => {
        $log.warn(`[Icon Service] Unable to download icon '${iconName}' by url '${url}'`);
        $log.warn(err);
        return defaultIcon;
      });
  }

}
